import styled from '@emotion/styled';

export const Error = styled.div`
  padding: 0 20px 20px;
  color: red;
`;